import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";
import api from "../../system/api";

export default class Invoice extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "invoice";
    static pluralName = "invoices";
    static displayName = "Invoice";
    constructor() { super(`${Invoice.kind}`, `${Invoice.singularName}`, `${Invoice.pluralName}`); }
    async getAll(query = {}) { return await this.fetch(qs.stringify({...query}, {encodeValuesOnly: true})); }
    async getById(id, query = {}) { return await this.find(id, {populate: "*", ...query}); }
    async downloadPdf(id, workspaceDocumentId) {
        try {
            const response = await api.get(`/invoices/${encodeURIComponent(id)}/pdf`, {
                ...this.getHeader(workspaceDocumentId),
                params: {downloadedAt: Date.now()},
                responseType: "blob",
            });
            return response.data;
        } catch (error) {
            throw this._normalizeError(error);
        }
    }
}
